import { DayHeaderInfo } from '@fullcalendar/react'
import { isToday } from 'date-fns'
import dayjs from 'dayjs'

export function dayHeaderClass(e: DayHeaderInfo) {
  return isToday(dayjs(e.date).add(13, 'hour').toDate())
    ? 'calendar-day-header FullCalendarHeaderCurrentDay'
    : 'calendar-day-header'
}
